<div wgPanelManager>
  <sem-loader #loaderComp [cssClasses]="'loader-mp-wrapper loader-opacity'"></sem-loader>
  <router-outlet></router-outlet>
</div>